import { ValidationErrors } from 'final-form';
import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import styled from 'styled-components';

import { Notification } from '@xsolla/ui-core';
import { AlertExclamation } from '@xsolla/ui-icons';

import { FieldSwitch } from '../../ui';
import CustomStorageCard from './CustomStorageCard';
import { CustomStorageFieldTypes } from './settings';
import { CustomFieldsWrapper, CustomStorageCardWrapper } from './style';

type Props = {
  errors: ValidationErrors;
};

const SwitchWrapper = styled.div`
  padding-top: 50px;
`;

const CustomStorageFields = ({ errors }: Props): JSX.Element => {
  const intl = useIntl();

  return (
    <CustomFieldsWrapper>
      <Notification
        icon={AlertExclamation}
        palette="brand"
        caption={
          // eslint-disable-next-line react/jsx-wrap-multilines
          <FormattedMessage
            id="user-data-base.settings.user-storage.custom.notification.description"
            values={{
              ul: (chunk: string) => (
                <ul style={{ padding: '0 0 0 24px', margin: '0' }}>{chunk}</ul>
              ),
              li: (chunk: string) => <li>{chunk}</li>
            }}
          />
        }>
        {intl.formatMessage({
          id: 'user-data-base.settings.user-storage.custom.notification.title'
        })}
      </Notification>
      <CustomStorageCardWrapper>
        {Object.values(CustomStorageFieldTypes).map((fieldName, index) => (
          <>
            <CustomStorageCard fieldName={fieldName} errors={errors} isOpened={false} />
          </>
        ))}
      </CustomStorageCardWrapper>
      <SwitchWrapper>
        <FieldSwitch
          name="add_social_access_token"
          label={
            intl.messages[
              `user-data-base.settings.user-storage.custom.add_social_access_token.label`
            ]
          }
        />
      </SwitchWrapper>
      <FieldSwitch
        name="social_url_linking_server_custom_id"
        label={
          intl.messages[
            `user-data-base.settings.user-storage.custom.add_user_account_linking.label`
          ]
        }
        caption={intl.formatMessage({
          id: 'user-data-base.settings.user-storage.custom.add_user_account_linking.description'
        })}
      />
    </CustomFieldsWrapper>
  );
};

export default CustomStorageFields;
